import React, { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as source from "sources/books/popups";
import Form from "./form";
import List from "./list";
import Show from "./show";

const Popups = (props) => {
    useEffect(() => {
        return () => props.clearParams("popups");
    }, []);

    const { match, location, history } = props;
    const rootUrl = `${match.path}/list`;
    const back = () => history.push(rootUrl);
    return (
        <div className="page-content">
            <Switch location={location}>
                <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                <Route
                    exact
                    path={rootUrl}
                    render={() => (
                        <List
                            {...props}
                            isTable
                            transition="full"
                            title="Pop-up уведомления"
                            nofilter
                            createBtnText="Создать pop-up уведомление"
                        />
                    )}
                />
                <Route
                    path={`${rootUrl}/:id`}
                    render={(rest) => (
                        <Show {...rest} transition="full" title="Pop-up уведомление" back={back} source={source} />
                    )}
                />
                <Route
                    path={`${match.path}/new`}
                    render={() => (
                        <Form {...props} title="Создать pop-up уведомление" back={back} submit={source.apply} />
                    )}
                />
            </Switch>
        </div>
    );
};

export default Popups;
